var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 10.8013L21.536 12.6373L20.264 13.9093L12.5 6.14532L4.73599 13.9093L3.46399 12.6373L12.5 3.60132L17.3 8.40132V6.00132H19.7V10.8013ZM12.5 7.84932L19.7 15.0373V22.2013H5.29999V15.0373L12.5 7.84932ZM14.9 21.0013V15.0013H10.1V21.0013H14.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.103f2fefbf185e27e6c81336275cc2d6.svg";
export { ForwardRef as ReactComponent };